/* Exomila · Sélecteur "Quel exosquelette pour vous ?" : vanilla JS, sans framework.
   Horizon n'injecte pas fiablement le {% javascript %} de section : ce fichier est chargé
   en asset via `{{ 'exo-selector.js' | asset_url | script_tag }}` dans exo-selector.liquid. */
(function () {
  'use strict';

  var TOTAL_STEPS = 3;

  function initSelector(root) {
    var answers = {};
    var currentStep = 1;

    var progressDots = root.querySelectorAll('[data-step-dot]');
    var questions = root.querySelectorAll('[data-sel-question]');
    var resultEl = root.querySelector('[data-sel-result]');
    var cards = root.querySelectorAll('[data-sel-card]');
    var restartBtn = root.querySelector('[data-sel-restart]');
    var tagInput = root.querySelector('[data-sel-tag-input]');

    function showStep(step) {
      currentStep = step;
      questions.forEach(function (q) {
        var isTarget = parseInt(q.getAttribute('data-step'), 10) === step;
        q.hidden = !isTarget;
      });
      progressDots.forEach(function (dot) {
        var dotStep = parseInt(dot.getAttribute('data-step-dot'), 10);
        dot.classList.toggle('is-active', dotStep === step);
        dot.classList.toggle('is-done', dotStep < step);
      });
      resultEl.hidden = true;
      var activeQuestion = root.querySelector('[data-step="' + step + '"]');
      if (activeQuestion) {
        var heading = activeQuestion.querySelector('.exo-sel__q-title');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
      }
    }

    function computeWinner() {
      var scores = { marche: 0, endurance: 0, elan: 0 };
      Object.keys(answers).forEach(function (q) {
        var val = answers[q];
        if (scores.hasOwnProperty(val)) {
          scores[val] += 1;
        }
      });
      var winner = 'marche';
      var best = -1;
      ['marche', 'endurance', 'elan'].forEach(function (key) {
        if (scores[key] > best) {
          best = scores[key];
          winner = key;
        }
      });
      return winner;
    }

    function showResult() {
      var winner = computeWinner();
      questions.forEach(function (q) { q.hidden = true; });
      cards.forEach(function (card) {
        card.hidden = card.getAttribute('data-sel-card') !== winner;
      });
      resultEl.hidden = false;
      if (tagInput) {
        tagInput.value = 'selecteur-exosquelette, resultat-' + winner;
      }
      resultEl.setAttribute('tabindex', '-1');
      resultEl.focus({ preventScroll: true });
      root.dispatchEvent(new CustomEvent('exo-selector:result', { detail: { winner: winner }, bubbles: true }));
    }

    function handleAnswerClick(e) {
      var btn = e.currentTarget;
      var question = btn.getAttribute('data-question');
      var value = btn.getAttribute('data-value');
      answers[question] = value;

      var group = btn.closest('[data-sel-question]');
      if (group) {
        group.querySelectorAll('[data-sel-answer]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
      }
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');

      var nextStep = currentStep + 1;
      window.setTimeout(function () {
        if (nextStep <= TOTAL_STEPS) {
          showStep(nextStep);
        } else {
          showResult();
        }
      }, 180);
    }

    root.querySelectorAll('[data-sel-answer]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', 'false');
      btn.addEventListener('click', handleAnswerClick);
    });

    root.querySelectorAll('[data-sel-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var prev = Math.max(1, currentStep - 1);
        showStep(prev);
      });
    });

    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        answers = {};
        root.querySelectorAll('[data-sel-answer]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        cards.forEach(function (card) { card.hidden = true; });
        showStep(1);
      });
    }

    showStep(1);
  }

  function init() {
    var roots = document.querySelectorAll('[data-exo-selector]');
    roots.forEach(initSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-exo-selector]') : null;
    if (root) { initSelector(root); }
  });
})();
